<template>
  <!-- <a-modal
    :visible="visible"
    :footer="null"
    :header="null"
    @cancel="closeModal"
    wrapClassName="act-now-chat-ai-modal"
  > -->
  <div class="act-now-chat-ai-modal-container">
    <a-button @click.stop="closeModal" class="act-now-chat-ai-modal-container__arrow-back">
      <img
        src="@/assets/icons/left-arrow-icon.png"
        alt="icon"
      />
    </a-button>
    <div class="act-now-chat-ai-modal-container__header">
      <img
        src="@/assets/icons/glocal-ai-icon-navbar-black.svg"
        alt="Icon"
        class="act-now-chat-ai-modal-container__header--icon"
      />
      <h1 class="act-now-chat-ai-modal-container__header--title">
        Welcome to Glocal AI
      </h1>
    </div>
    <div class="act-now-chat-ai-modal-container__body">
      <div
        v-for="(chat, index) in actNowChat"
        :key="'chat-' + chat?.id"
        class="act-now-chat-ai-modal-container__body--chat-wrapper"
      >
        <button @click="handleCopy(index)" class="act-now-chat-ai-modal-container__body--chat-wrapper--copied-btn">
          <img src="@/assets/icons/copy-icon.png" alt="Copy" />
          {{ copiedKeys[`chat-${index}`] ? "Copied!" : "Copy" }}
        </button>
        <p
          :ref="'chatText' + index"
          v-html="chat.chat"
          class="act-now-chat-ai-modal-container__body--chat-wrapper--description"
        ></p>
      </div>
      <div
        v-for="(selectedAuthorities, index) in actNowSelectedAuthorities"
        :key="'authority-' + selectedAuthorities?.id"
        class="select-user-card"
      >
        <div v-if="selectedAuthorities?.name" class="select-user-card__field">
          <p><span>Name: </span>{{ selectedAuthorities?.name }}</p>
          <button class="copy-btn" @click="copyToClipboard(selectedAuthorities.name, 'name-' + index)">
            <img src="@/assets/icons/copy-icon.png" alt="Copy" />
            <div v-if="copiedKeys[`name-${index}`]" class="copied"><p>Copied!</p></div>
          </button>
        </div>

        <div v-if="selectedAuthorities?.email" class="select-user-card__field">
          <p><span>Email: </span>{{ selectedAuthorities?.email }}</p>
          <button class="copy-btn" @click="copyToClipboard(selectedAuthorities.email, 'email-' + index)">
            <img src="@/assets/icons/copy-icon.png" alt="Copy" />
            <div v-if="copiedKeys[`email-${index}`]" class="copied"><p>Copied!</p></div>
          </button>
        </div>
      </div>
    </div>
    <div class="act-now-chat-ai-modal-container__footer">
      <div class="act-now-chat-ai-modal-container__footer--comment">
        <img
          src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D"
        />
        <textarea cols="30" placeholder="Submit inquiry..."></textarea>
        <div class="buttons">
          <a-button :loading="loading" class="btn">
            <i class="icon icon-send"></i>
          </a-button>
        </div>
      </div>
    </div>
  </div>
  <!-- </a-modal> -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      copiedKeys: {},
    };
  },
  computed: {
    ...mapGetters({
      actNowSelectedAuthorities: "discover/actNowSelectedAuthorities",
      actNowChat: "discover/actNowChat",
    }),
  },
  methods: {
    closeModal() {
      this.$emit("handle-close", false);
    },
    copyToClipboard(text, key) {
      if (!text) return;

      const copyText = async () => {
        try {
          await navigator.clipboard.writeText(text);
          this.copiedKeys[key] = true;
          setTimeout(() => {
            this.copiedKeys[key] = false;
          }, 2000);
        } catch (err) {
          // Fallback for unsupported mobile browsers
          const textarea = document.createElement("textarea");
          textarea.value = text;
          textarea.setAttribute("readonly", "");
          textarea.style.position = "absolute";
          textarea.style.left = "-9999px";
          document.body.appendChild(textarea);
          textarea.select();

          try {
            const successful = document.execCommand("copy");
            if (successful) {
              this.copiedKeys[key] = true;
              setTimeout(() => {
                this.copiedKeys[key] = false;
              }, 2000);
            } else {
              alert("Copy failed");
            }
          } catch (err) {
            console.error("Fallback copy failed", err);
            alert("Copy not supported on this device.");
          }

          document.body.removeChild(textarea);
        }
      };

      copyText();
    },
    handleCopy(index) {
      const el = this.$refs["chatText" + index];
      if (el) {
        const text = el.innerText || el.textContent;
        this.copyToClipboard(text, `chat-${index}`);
      }
    }
  },
};
</script>

<style lang="scss">
.act-now-chat-ai-modal-container {
  &__arrow-back {
    width: max-content;
    height: max-content;
    line-height: normal;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
    box-shadow: none;
    background-color: transparent;
    padding: 0 !important;
    margin: 2.2rem 0 0 2rem;
    cursor: pointer;
    img {
      width: 2.8rem;
      height: auto;
    }
    @include respond(phone-large) {
      img {
        width: 4rem;
      }
    }
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 2.5rem;
    margin-top: -5.7rem;
    gap: 1rem;
    &--title {
      font-size: 2rem;
      font-family: $font-primary-bold;
      color: $color-black;
      margin-bottom: 0;
      line-height: normal;
    }
    &--icon {
      width: 4.5rem;
      height: auto;
    }
    @include respond(phone-large) {
      margin-top: -7rem;
      &--title {
        font-size: 3.2rem;
      }
      &--icon {
        width: 7rem;
      }
    }
  }
  &__body {
    overflow-y: auto;
    max-height: calc(100vh - 40rem);
    padding: 0rem 2.5rem;
    @include respond(phone-large) {
      max-height: calc(100vh - 60rem);
    }
    &--chat-wrapper {
      margin-bottom: 1rem;
      &--copied-btn {
        display: flex;
        align-items: center;
        background-color: #e7e7e7;
        padding: 0.4rem 0.6rem;
        position: sticky;
        top: 0;
        border: none;
        outline: none;
        font-size: 1.4rem;
        line-height: normal;
        font-family: $font-primary-medium;
        cursor: pointer;
        gap: 0.5rem;
        margin-left: auto;
        img {
          width: 1.5rem;
          height: auto;
        }
        @include respond(phone-large) {
          font-size: 1.8rem;
          padding: 0.8rem 1rem;
          img {
            width: 1.7rem;
          }
        }
      }
      &--description {
        font-size: 1.6rem;
        font-family: $font-primary;
        color: $color-black;
        margin-bottom: 0;
        line-height: 2.2rem;
        @include respond(phone-large) {
          font-size: 2.2rem;
          line-height: 3.3rem;
        }
        p, h1, h2, h3, h4, h5, h6, a {
          font-size: inherit;
          line-height: inherit;
          margin-bottom: 0.8rem;
        }
        a {
          color: $color-links;
        }
      }
    }
    .select-user-card {
      margin-top: 1.5rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      @include respond(phone-large) {
        gap: 1.2rem;
      }
      &__field {
        display: flex;
        align-items: center;
        gap: 0.7rem;
        p {
          font-size: 1.4rem;
          font-family: $font-primary;
          margin-bottom: 0;
          display: flex;
          align-items: center;
          gap: 0.7rem;
          color: #4a4949;
          span {
            font-family: $font-primary-medium;
            color: $color-black;
            opacity: 0.8;
          }
        }
        .icon {
          width: 1.6rem;
          height: auto;
        }

        .copy-btn {
          border: none;
          outline: none;
          border-radius: 0.5rem;
          width: 2rem;
          height: 2rem;
          background-color: #8080803d;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin-left: 0.3rem;
          position: relative;
          img {
            width: 1rem;
            height: auto;
          }
          .copied {
            position: absolute;
            box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
            bottom: 0;
            padding: 0.5rem 1rem;
            border-radius: 0.5rem;
            z-index: 1;
            background-color: $color-white;
            right: -6rem;
            p {
              font-size: 1rem;
              font-family: $font-primary;
              margin-bottom: 0;
              line-height: normal;
            }
          }
        }

        @include respond(phone-large) {
          gap: 1rem;
          p {
            font-size: 2.2rem;
          }
          .icon {
            width: 2.7rem !important;
          }
          .telephone-icon {
            width: 2.6rem !important;
          }
          .copy-btn {
            width: 3.5rem;
            height: 3.5rem;
            img {
              width: 1.8rem;
            }
            .copied {
              right: -9rem;
              bottom: 0.4rem;
              z-index: 22;
              p {
                font-size: 1.8rem;
              }
            }
          }
        }
      }
    }
    &::-webkit-scrollbar {
      width: 0.4rem;
      height: 0.4rem;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 0.8rem;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $color-primary;
      border-radius: 0.8rem;
    }
  }
  &__footer {
    width: calc(100% - 8rem);
    padding: 1.8rem 2rem;
    background-color: transparent;
    background-color: $color-white;
    width: 100%;
    border-end-start-radius: 2rem;
    border-end-end-radius: 2rem;
    &--comment {
      background-color: #eeeeee;
      padding: 0 1.4rem;
      border-radius: 1rem;
      display: flex;
      align-items: center;
      margin: 0 auto;
      img {
        width: 3rem;
        height: 3rem;
        border-radius: 100%;
        object-fit: fill;
        @include respond(phone-large) {
          width: 4.5rem;
          height: 4.5rem;
        }
      }
      textarea {
        padding: 0.8rem 1.5rem;
        margin: 0.5rem 0;
        border: none;
        font-size: 1.6rem;
        font-family: $font-primary;
        box-shadow: none;
        outline: none;
        line-height: 2.2rem;
        color: $color-black;
        background-color: transparent;
        resize: none;
        width: 100%;
        @include respond(phone-large) {
          font-size: 2.2rem;
          line-height: 3.3rem;
        }
        &::placeholder {
          color: #868686;
        }
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .buttons {
        display: flex;
        align-items: center;
        .disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        .ant-btn {
          width: 5rem;
          background-color: $color-primary;
          border: none;
          outline: none;
          height: 3rem;
          color: $color-white;
          border-radius: 100px !important;
          padding: 0 !important;
          span {
            line-height: normal;
          }
          .anticon {
            .anticon-spin {
              font-size: 1.5rem !important;
              color: $color-primary;
            }
          }
          &:hover,
          &:focus {
            background-color: $color-primary;
            color: $color-white;
          }
          .icon {
            font-size: 1.5rem;
            display: block;
            color: $color-white;
          }
          @include respond(phone-large) {
            height: 4rem;
            width: 7rem;
            .anticon {
              .anticon-spin {
                font-size: 2.2rem !important;
              }
            }
            .icon {
              font-size: 2rem;
            }
          }
        }
      }
    }
  }
}
</style>
